import React, { useEffect } from 'react';
import { Line, LineChart, ResponsiveContainer, Tooltip, XAxis } from "recharts";
import moment from 'moment';
import { useSelector, useDispatch } from "react-redux";
import { Col, Row } from "antd";

import Widget from "../../components/Widget/index";

import { fetchGeneralTotal, fetchGeneralTotalCumulative, fetchMerchantTotal, fetchMerchantTotalCumulative } from "../../redux/actions/Aggregate";
import { generateDateTimeRange } from '../../util/lib';
import { fetchMerchantAccounts } from '../../redux/actions/Data';


const TrafficRaiseCard = ({ merchantId }) => {
  const dispatch = useDispatch();
  const { timezone } = useSelector(({ settings }) => settings);
  const { data: generalHourly } = useSelector(({ aggregate }) => aggregate.generalHourly);
  const { data: generalTotalCumulativeData, loading: loadingGeneralTotalCumulativeData } = useSelector(({ aggregate }) => aggregate.generalTotal);
  const { data: merchantHourly } = useSelector(({ aggregate }) => aggregate.merchantHourly);
  const { data: merchantTotalCumulativeData, loading: loadingMerchantTotalCumulativeData } = useSelector(({ aggregate }) => aggregate.merchantTotal);
  const { data: merchantAccounts, loading: loadingMerchants } = useSelector(({ data }) => data.merchantAccounts);


  const todaysDate = moment().format('YYYY-MM-DD');
  const todaysDateWithTimezone = generateDateTimeRange(todaysDate, timezone);
  const yesterday = moment().subtract(1, 'days').format('YYYY-MM-DD');
  const yesterdayWithTimezone = generateDateTimeRange(yesterday, timezone);

  useEffect(() => {
    if (merchantId) {
      dispatch(fetchMerchantTotal(
        merchantId,
        'CARD',
        "ALL",
        'COMPLETED',
        'hour',
        'None',
        `start=${todaysDateWithTimezone.start}&end=${todaysDateWithTimezone.end}`));

      dispatch(fetchMerchantTotalCumulative(
        merchantId,
        'CARD',
        'ALL',
        'COMPLETED',
        'hour',
        'today',
        `start=${todaysDateWithTimezone.start}&end=${todaysDateWithTimezone.end}`));

      dispatch(fetchMerchantTotalCumulative(
        merchantId,
        'CARD',
        'ALL',
        'COMPLETED',
        'hour',
        'yesterday',
        `start=${yesterdayWithTimezone.start}&end=${yesterdayWithTimezone.end}`));

    } else {
      dispatch(fetchMerchantAccounts());
    }

  }, [dispatch, merchantId, timezone]);

  useEffect(() => {
    if (merchantAccounts && merchantAccounts.length > 0) {
      const merchantIds = `merchant_id={"$in": [${merchantAccounts.map((account) => `"${account._id}"`).join(',')}]}`;
      const queries = [
        merchantIds,
        `start=${moment(todaysDateWithTimezone.start).format('YYYY-MM-DD')}`,
        `end=${moment(todaysDateWithTimezone.end).format('YYYY-MM-DD')}`
      ];

      const params = queries.join('&');

      dispatch(fetchGeneralTotal(
        'CARD',
        "ALL",
        'COMPLETED',
        'hour',
        'None',
        params
      ));

      dispatch(fetchGeneralTotalCumulative(
        'CARD',
        'ALL',
        'COMPLETED',
        'hour',
        'today',
        params
      ));

      dispatch(fetchGeneralTotalCumulative(
        'CARD',
        'ALL',
        'COMPLETED',
        'hour',
        'yesterday',
        params
      ));
    }
  }, [merchantAccounts]);

  const data = merchantId ? merchantHourly : generalHourly;
  const totalCumulativeData = merchantId ? merchantTotalCumulativeData : generalTotalCumulativeData;
  const loading = merchantId ? loadingMerchantTotalCumulativeData : loadingGeneralTotalCumulativeData;
  const totalAmountToday = totalCumulativeData?.total_amount_today;
  const totalAmountYesterday = totalCumulativeData?.total_amount_yesterday;

  return (
    <Widget>
      <Row className="gx-align-items-center">
        <Col lg={4} md={4} sm={12} xs={12}>
          <div className="gx-actchart gx-px-8">
            <h2 className="gx-fs-xxxl gx-font-weight-medium gx-mb-1 gx-text-black">
              {
                !loading
                  ? (totalAmountToday > 0 && totalAmountYesterday > 0)
                    ? (((totalAmountToday - totalAmountYesterday) / totalAmountYesterday) * 100).toFixed(0)
                    : 0
                  : (<i className="icon icon-loading gx-fs-xxl gx-text-primary" />)
              }%
              <i className="icon icon-menu-up gx-fs-sm" />
            </h2>
            <p className="gx-mb-0">Rate ~24hrs</p>
          </div>
        </Col>
        <Col lg={20} md={20} sm={24} xs={24}>
          <ResponsiveContainer width="100%" height={95}>
            <LineChart data={data} margin={{ top: 5, right: 5, left: 5, bottom: 5 }}>
              <XAxis dataKey="timestamp" tickFormatter={timeStr => moment(timeStr).format('HH:mm')} />
              <Tooltip />
              <Line dataKey="total_amount" stroke="#038FDE" strokeWidth={2} />
            </LineChart>
          </ResponsiveContainer>
        </Col>
      </Row>
    </Widget>
  );
};

export default TrafficRaiseCard;
